export const maskAnimation = ( target ) => {
	document.defaultView.addEventListener( 'load', () => {
		const elem = document.getElementById( target );
		const observer = new IntersectionObserver( ( entries ) => {
			for ( const e of entries ) {
				if ( e.isIntersecting ) {
					elem.style.right = '-100%';
				}
			}
		} );

		if ( elem ) {
			observer.observe( elem );
		}
	} );
};
